import React, {useContext, useEffect} from "react";
import {useHistory} from "react-router-dom";
import {apollo_useRowStyles} from "../../atom/Apollo_styles";
import {ApolloMessage} from "../../atom/Apollo_Mesasge";
import {
  get_apollo_role_path,
  userdetail_path
} from "../../atom/Apollo_links";
import {ApolloContext} from "../../atom/Apollo_Context";
import {PageUser, AccountGroupRoles} from "../../pages/USER/UserModel";
import {ApolloAxios} from "../../atom/Apollo_ApiRequest3";
// 認証期間切れの処理
import {ApolloExpired} from "../../atom/Apollo_Expired";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';

// エラーメッセージ
const ERROR_MESSGAE = [
  "ユーザー情報の取得に失敗しました。",
];

export default function ApolloRoleList(props: { row: AccountGroupRoles, pageUsers: PageUser[] }) {
  const history = useHistory();
  const {row, pageUsers} = props;
  const classes = apollo_useRowStyles();
  type Users = {
    userId: string,
    mailaddress: string,
    familyName: string,
    firstName: string,
  }

  const [users, setUsers] = React.useState<Users[]>([]);
  let arrUsers: Array<Users> = [];

  const {state} = React.useContext(ApolloContext);
  const {data, setmsg} = useContext(ApolloMessage);

  useEffect(() => {
    const url = `${get_apollo_role_path}/${row.roleId}`;
    ApolloAxios.get(url).then((response) => {
      let result1 = response.data.result;
      let userIds = result1.userIds;
      let splitUserIds = userIds.split(",");

      pageUsers.forEach(function (pageUser: any) {
        let index = splitUserIds.indexOf(String(pageUser.userId));

        if (index >= 0) {
          var u1: Users = {
            userId: pageUser.userId,
            mailaddress: pageUser.mailaddress,
            familyName: pageUser.familyName,
            firstName: pageUser.firstName,
          };
          arrUsers.push(u1);
        }
      })

      setUsers(arrUsers);
    }).catch((err) => {
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, ERROR_MESSGAE[0], data, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "ユーザー情報の取得に失敗しました"
        }
      });
      return;
    });
  }, []);

  return (
    <React.Fragment>
      <Box margin={1}>
        <Typography variant="subtitle1" gutterBottom component="div">
          ロールを持つユーザー一覧
        </Typography>
        <Table size="small" aria-label="purchases">
          <TableHead>
            <TableRow>
              <TableCell align="left">ユーザーID</TableCell>
              <TableCell align="left">メールアドレス</TableCell>
              <TableCell align="left">氏名（姓）</TableCell>
              <TableCell align="left">氏名（名）</TableCell>
              <TableCell align="left">詳細</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users ? users?.map((user) => (
              <TableRow key={user.userId}>
                <TableCell component="th" scope="row" align="left">
                  {user.userId}
                </TableCell>
                <TableCell align="left">{user.mailaddress}</TableCell>
                <TableCell align="left">{user.familyName}</TableCell>
                <TableCell align="left">{user.firstName}</TableCell>
                <TableCell align="left">
                  <KeyboardArrowRightIcon
                    onClick={() => history.push(userdetail_path + user.userId)}
                    className={classes.link}
                    style={{cursor: "pointer"}}
                  />
                </TableCell>
              </TableRow>
            )) : ""}
          </TableBody>
        </Table>
      </Box>
    </React.Fragment>
  );
}
